import React from 'react';

export function CircleOutline(props) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="prefix__feather prefix__feather-circle"
            {...props}
        >
            <circle cx={12} cy={12} r={10} />
        </svg>
    );
}
